// extracted by mini-css-extract-plugin
module.exports = {"message":"forgot-password-form-module--message--1Xszd"};